import VueRouter, { RouteConfig } from 'vue-router'

const AboutSaas = () => import('../views/AboutSaas.vue')
const AboutExam = () => import('../views/AboutExam.vue')
const AboutCompetition = () => import('../views/AboutCompetition.vue')
const AboutMovePractice = () => import('../views/AboutMovePractice.vue')
const AboutClazzroomQuiz = () => import('../views/AboutClazzroomQuiz.vue')
const AboutContactUs = () => import('../views/Contactus.vue')

export const aboutSaasRoute: RouteConfig = {
  path: '/about-saas',
  name: 'about_saas',
  component: AboutSaas,
  meta: {
    title: '体智云',
  },
}

export const aboutExamRoute: RouteConfig = {
  path: '/about-exam',
  name: 'about_exam',
  component: AboutExam,
  meta: {
    title: '功能描述',
  },
}

export const aboutCompetitionRoute: RouteConfig = {
  path: '/about-competition',
  name: 'about_competition',
  component: AboutCompetition,
  meta: {
    title: '功能描述',
  },
}

export const aboutMovePracticeRoute: RouteConfig = {
  path: '/about-move-practice',
  name: 'about_move_practice',
  component: AboutMovePractice,
  meta: {
    title: '功能描述',
  },
}

export const aboutClazzroomQuizRoute: RouteConfig = {
  path: '/about-clazzroom-quiz',
  name: 'about_clazzroom_quiz',
  component: AboutClazzroomQuiz,
  meta: {
    title: '功能描述',
  },
}

export const aboutContactUsRoute: RouteConfig = {
  path: '/about-contact-us',
  name: 'about_contact_us',
  component: AboutContactUs,
  meta: {
    title: '联系我们',
  },
}

export default [
  aboutSaasRoute,
  aboutExamRoute,
  aboutCompetitionRoute,
  aboutMovePracticeRoute,
  aboutClazzroomQuizRoute,
  aboutContactUsRoute,
]

export function navigateToAboutExam(router: VueRouter) {
  router.push({ name: aboutExamRoute.name })
}

export function navigateToAboutCompetition(router: VueRouter) {
  router.push({ name: aboutCompetitionRoute.name })
}

export function navigateToAboutMovePractice(router: VueRouter) {
  router.push({ name: aboutMovePracticeRoute.name })
}

export function navigateToAboutClazzroomQuiz(router: VueRouter) {
  router.push({ name: aboutClazzroomQuizRoute.name })
}
